import { render, staticRenderFns } from "./VerArchivos.vue?vue&type=template&id=3fd7c27f&"
import script from "./VerArchivos.vue?vue&type=script&lang=js&"
export * from "./VerArchivos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports